import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { Grid } from 'react-flexbox-grid';
import Promise from 'bluebird';
import Loader from '~loader';

import * as componentActions from '~actions/component_actions';

import ListLayout from './event_layouts/list';
import SideBySideLayout from './event_layouts/large-list';
import ColumnLayout from './event_layouts/column_layout';
import CalendarLayout from './event_layouts/calendar';
import Header from './header';
import Featured from './event_layouts/feature';
import NoEvents from './no_events';
import PremiumFeatureBanner from './premium_feature_banner';

class Widget extends Component {
  constructor() {
    super();
    this.delayedResize = _.debounce(this.resizeComponent.bind(this), 800);

    this.state = {
      initialHeight: 0,
      showPremiumFeatureBanner: false,
    };
  }

  componentDidMount() {
    this.registerEventListeners();
    // Hack to wait for react to finish rendering before updating the iframe
    setTimeout(() => {
      this.setState({
        initialHeight: this.updateCompHeight(),
      });
    }, 2000);
  }

  componentDidUpdate() {
    this.updateCompHeight();
  }

  updateCompHeight = () => {
    const height = this.containerEl.clientHeight;
    Wix.setHeight(height);
    return height;
  };

  resizeComponent = () => {
    if (document.documentElement.clientHeight < this.state.initialHeight) {
      Wix.setHeight(this.state.initialHeight);
    } else {
      this.setState({
        initialHeight: this.containerEl.clientHeight,
      });
    }
  };

  registerEventListeners = () => {
    const { publish, updateSettingsState, deleteSettings, isPremium } = this.props;

    Wix.addEventListener(Wix.Events.COMPONENT_DELETED, deleteSettings);

    Wix.addEventListener(Wix.Events.SITE_PUBLISHED, () => {
      publish();
    });

    window.addEventListener('resize', this.delayedResize);

    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, this.delayedResize);
    Wix.addEventListener(
      Wix.Events.SETTINGS_UPDATED,
      ({
        key,
        value,
        shouldFetchEvents = false,
        isPremiumKey = false,
        resizeWidget = false,
        hardRefresh = false,
      }) => {
        if (hardRefresh) {
          window.location.reload();
        }
        (shouldFetchEvents ? this.props.getEvents() : Promise.resolve()).then(() => {
          if (!_.isUndefined(key) && !_.isUndefined(value)) {
            updateSettingsState(key, value);
          }
          if (resizeWidget) {
            _.defer(this.updateCompHeight);
          }

          if (!isPremium && isPremiumKey) {
            this.setState({
              showPremiumFeatureBanner: true,
            });

            setTimeout(() => {
              this.setState({
                showPremiumFeatureBanner: false,
              });
            }, 8000);
          }
        });
      }
    );
  };

  layoutComponent(settings, isMobile) {
    const layoutDesign = settings.get('layoutDesign');
    if (isMobile) {
      return { component: ListLayout };
    }
    const mapping = {
      list: { component: ListLayout },
      sideBySide: { component: SideBySideLayout },
      feature: { component: Featured },
      calendar: { component: CalendarLayout },
      twoColumns: { component: ColumnLayout, props: { columns: 2 } },
      threeColumns: { component: ColumnLayout, props: { columns: 3 } },
    };
    return mapping[layoutDesign];
  }

  render() {
    const { events, settings } = this.props;
    const isMobile = Wix.Utils.getDeviceType() === 'mobile';
    const slicedEvents = settings.get('showAllEvents')
      ? events
      : events.slice(0, settings.get('maxEvents'));
    const layout = this.layoutComponent(settings, isMobile);
    const LayoutComponent = layout.component;
    const props = layout.props || {} || this.state.showPremiumFeatureBanner;
    return (
      <div className="events-container" ref={containerEl => (this.containerEl = containerEl)}>
        {this.state.showPremiumFeatureBanner && <PremiumFeatureBanner />}
        <Grid className="widget" ref={w => (this.widget = w)}>
          {settings.get('showHeader') && <Header title={settings.get('widgetTitle')} />}
          {slicedEvents.count() === 0 ? (
            <NoEvents {...this.props} />
          ) : (
            <LayoutComponent
              {...props}
              events={slicedEvents}
              settings={settings}
              isMobile={isMobile}
            />
          )}
        </Grid>
      </div>
    );
  }
}

Widget.propTypes = {
  getEvents: PropTypes.func,
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  getSettings: PropTypes.instanceOf(Map).isRequired,
  updateSettingsState: PropTypes.func,
  publish: PropTypes.func,
  deleteSettings: PropTypes.func,
  isPremium: PropTypes.bool,
};

const mapStateToProps = state => ({
  events: state.component.get('events'),
  settings: state.component.get('settings'),
  isPremium: state.component.getIn(['settings', 'isPremium']),
  user: state.component.get('user'),
  loading: state.component.get('loading'),
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(componentActions, dispatch);
}

function WidgetContainer(props) {
  const prom = Promise.resolve([props.getSettings, props.getEvents]);
  const fetchData = () => prom.mapSeries(asyncMethodPassed => asyncMethodPassed());

  return (
    <Loader fetchData={fetchData} loadingText="Loading Events">
      <Widget {...props} />
    </Loader>
  );
}

WidgetContainer.propTypes = {
  getSettings: PropTypes.instanceOf(Map).isRequired,
  getEvents: PropTypes.instanceOf(Map).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);



// WEBPACK FOOTER //
// ./src/widget/widget.js